export async function deleteTeam(team) {
	const dialogId = Math.floor(100000 + Math.random() * 900000).toString();
	const self = this;
	this.$root.$on(dialogId, async ok => {
		if (ok) {
			const result = await self.$api.deleteTeam(team.id, team.name);
			if (result) {
				self.$root.$emit("refreshTeams");
				if (self.$route.path != '/teams') {
					self.$router.push('/teams');
				}
			}
			self.$root.$off(dialogId);
		}
	});
	this.$root.openYesNoDialog(
		dialogId,
		this.$t("Delete team"),
		this.$t("deleteConfirmation", { 0: team.name })
	);
}

export function getTeamsByLoggedUser(onlyLeader) {
	let allTeams = this.$session.getTeams();
	return allTeams.filter(t => t.users.some(m => m.id_user == this.$root.authObj.id_user && (!onlyLeader || m.is_lead)));
}

//Se l'utente loggato è un lead del team, ritorno tutti i membri
//Se l'utente loggato è un semplice operatore, ritorno solo se stesso
export function getTeamMembers(team, userLoggedIsLead) {
	let userMap = this.$session.getUsers().toMap("id");
	let members = userLoggedIsLead ? team.users.map(m => userMap[m.id_user]) : [userMap[this.$root.authObj.id_user]];
	return members;
}

export function getTeamsWithGroup(groupID) {
	return this.$session.getTeams().filter(t => t.groups.includes(groupID));
}

